<template>
  <div class="introduction oh">
    <div class="info" :class="{ 'has-list': list.length }">
      <div style="min-height:40px;" v-loading="loadingDetail">
        <span v-show="detail.Description" class="title">学院介绍：</span>
        <span class="content wb">{{ detail.Description }}</span>
      </div>
    </div>
    <div class="list" v-if="list.length">
      <div class="item csp" v-for="item of list" :key="item.Id" @click="go2detail(item)">
        <img :src="item.Cover" class="img img-cover" />
        <p class="title full-w">{{ item.Title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClinicalIntro',
  data() {
    const { id } = this.$utils.query2Obj(location.search);

    return {
      id,
      detail: {},
      loadingDetail: true,
      loadingList: true,
      msg: '',
      list: [],
    };
  },
  mounted() {
    this.$apis.train
      .getCollegeDetail({ Id: this.id })
      .then(res => {
        this.detail = res.data || {};
        this.loadingDetail = false;
      })
      .catch(() => {
        this.loadingDetail = false;
      });

    this.$apis.news
      .getNews({
        // Type: 2,
        CategoryType: 1,
        CategoryId: this.id,
        limit: 4,
      })
      .then(res => {
        this.list = res.data;
        console.log(111, this.list);
        this.loadingList = false;
      })
      .catch(() => {
        this.loadingList = false;
      });
  },
  methods: {
    go2detail(item) {
      location.href = `${this.$constants.routers.newsDetail.link}?type=news&id=${item.Id}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/css/variables.scss';

.introduction {
  .info {
    padding: 19px 32px;
    background: $clinical-theme-color;
    color: #fff;
    &.has-list {
      padding: 19px 32px 140px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      font-size: 14px;
    }
    ::v-deep {
      .el-loading-mask {
        background-color: transparent;
      }
    }
    padding-bottom: 29px;
  }

  .list {
    display: flex;
    margin-top: -115px;
    .item {
      /* flex: 1; */
      width: 25%;
      margin-right: 27px;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
      .img {
        width: 100%;
      }
      .title {
        padding: 10px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
        color: #fff;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>
